<template>
  <div class="busChannel">
    <div class="busChannel__header">
      <div class="busChannel__header__left">
        <h1 class="medium-title">Bus</h1>
      <div class="busChannel__header__left__menubar">
        <router-link class="regular-font" tag="li" :to="{name: 'busroute'}">Route</router-link>
        <router-link class="regular-font" tag="li" :to="{name: 'busplacement'}">Placement</router-link>
      </div>
    </div>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'adx-bus-channel',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addNew() {
        this.$router.push({name: 'addnewroute'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>